import { useState } from "react";
import { ArrowRight } from "lucide-react";

// HP4 draft — promo spotlight: left editorial copy with a small dot carousel,
// right an autoplaying brand video (reuses the live homepage video asset).
const VIDEO = "https://customer-assets-gfyr7b9c.emergentagent.net/job_e3513a08-18b3-459d-901e-2457595c9150/artifacts/qc63rkn0_Home%20page%20video.mp4";

const SLIDES = [
  { title: ["Give $15,", "get $15."], body: "Love your routine? Share Riversol with a friend. They get $15 off their first order and you get $15 in store credit — dermatologist-developed skincare, passed along." },
  { title: ["Free samples,", "every order."], body: "Discover more of the regimen with complimentary samples in every shipment — an easy way to find the next step for your skin." },
  { title: ["Try it risk-free", "for 60 days."], body: "Every Riversol order is backed by our 60-day money-back guarantee. See visible results or your money back — no questions asked." },
];

export const PromoSpotlightV4 = () => {
  const [i, setI] = useState(0);
  const s = SLIDES[i];
  return (
    <section className="bg-white py-8 lg:py-12" data-testid="hp4-promo-spotlight">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
        <div className="lg:col-span-5 flex gap-5">
          <div className="flex lg:flex-col gap-3 pt-2 shrink-0" data-testid="hp4-promo-dots">
            {SLIDES.map((_, idx) => (
              <button
                key={idx}
                type="button"
                aria-label={`Promo ${idx + 1}`}
                onClick={() => setI(idx)}
                data-testid={`hp4-promo-dot-${idx}`}
                className={`w-2.5 h-2.5 rounded-full border transition-colors ${idx === i ? "bg-riversol-blue border-riversol-blue" : "bg-transparent border-neutral-300 hover:border-riversol-blue"}`}
              />
            ))}
          </div>
          <div>
            <h2 className="text-[30px] sm:text-[36px] lg:text-[44px] leading-[1.05] tracking-[-0.02em] text-neutral-900">
              <span className="block">{s.title[0]}</span>
              <span className="block italic text-riversol-blue">{s.title[1]}</span>
            </h2>
            <p className="mt-4 text-[15px] lg:text-[16px] text-neutral-600 leading-relaxed max-w-[26rem]">{s.body}</p>
            <a
              href="https://www.riversol.com/collections/all"
              data-testid="hp4-promo-cta"
              className="group mt-7 inline-flex items-center gap-2 bg-riversol-blue text-white rounded-full px-7 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-riversol-blueLight transition-colors"
            >
              Learn more
              <ArrowRight size={15} strokeWidth={1.8} className="transition-transform group-hover:translate-x-0.5" />
            </a>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="relative aspect-[16/10] overflow-hidden rounded-sm bg-neutral-100">
            <video src={VIDEO} autoPlay muted loop playsInline className="w-full h-full object-cover" data-testid="hp4-promo-video" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSpotlightV4;
